"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const shuffle_1 = __importDefault(require("lodash/shuffle"));
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const helpers_1 = require("evolution-common/lib/utils/helpers");
const WithSurveyContextHoc_1 = require("../hoc/WithSurveyContextHoc");
const Widget_1 = require("../survey/Widget");
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const useSectionTemplate_1 = require("../hooks/useSectionTemplate");
const SectionProgressBar_1 = __importDefault(require("./SectionProgressBar"));
const Section = (props) => {
    var _a;
    const { preloaded } = (0, useSectionTemplate_1.useSectionTemplate)(props);
    // Scroll to top when the section is rendered
    react_1.default.useEffect(() => {
        window.scrollTo(0, 0);
    }, [props.shortname]);
    // TODO: This should not be done here. Wrong responsability. Move elsewhere.
    const getSortedWidgetShortnames = () => {
        let hasRandomOrderWidgets = false;
        let randomGroup = undefined;
        const randomGroupsIndexes = {};
        const randomGroupsStartIndexes = {};
        const sortedShortnames = [];
        const countWidgets = props.sectionConfig.widgets.length;
        const unsortedWidgetShortnames = [];
        // shuffle random groups indexes:
        for (let i = 0; i < countWidgets; i++) {
            const widgetShortname = props.sectionConfig.widgets[i];
            const widgetConfig = props.surveyContext.widgets[widgetShortname];
            unsortedWidgetShortnames.push(widgetShortname);
            if (widgetConfig === undefined) {
                continue;
            }
            if (widgetConfig.randomOrder === true) {
                hasRandomOrderWidgets = true;
                randomGroup = widgetConfig.randomGroup;
                if (randomGroup && !randomGroupsIndexes[randomGroup]) {
                    randomGroupsIndexes[randomGroup] = [];
                    randomGroupsStartIndexes[randomGroup] = i;
                }
                else if (randomGroup) {
                    randomGroupsIndexes[randomGroup].push(i);
                }
            }
        }
        if (hasRandomOrderWidgets) {
            for (const randomGroup in randomGroupsIndexes) {
                const randomGroupIndexes = (0, shuffle_1.default)(randomGroupsIndexes[randomGroup]);
                for (let j = 0, count = randomGroupIndexes.length; j < count; j++) {
                    sortedShortnames[randomGroupsStartIndexes[randomGroup] + j] =
                        unsortedWidgetShortnames[randomGroupIndexes[j]];
                }
            }
        }
        for (let i = 0; i < countWidgets; i++) {
            if (sortedShortnames[i] === undefined) {
                sortedShortnames[i] = unsortedWidgetShortnames[i];
            }
        }
        return sortedShortnames;
    };
    const sortedWidgetShortnames = react_1.default.useMemo(() => getSortedWidgetShortnames(), [props.sectionConfig.widgets]);
    if (!preloaded) {
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    const widgetsComponentByShortname = {};
    (0, helpers_1.devLog)('%c rendering section ' + props.shortname, 'background: rgba(0,0,255,0.1);');
    for (let i = 0, count = props.sectionConfig.widgets.length; i < count; i++) {
        const widgetShortname = props.sectionConfig.widgets[i];
        widgetsComponentByShortname[widgetShortname] = (react_1.default.createElement(Widget_1.Widget, { key: widgetShortname, currentWidgetShortname: widgetShortname, nextWidgetShortname: props.sectionConfig.widgets[i + 1], sectionName: props.shortname, interview: props.interview, errors: props.errors, user: props.user, loadingState: props.loadingState, startUpdateInterview: props.startUpdateInterview, startAddGroupedObjects: props.startAddGroupedObjects, startRemoveGroupedObjects: props.startRemoveGroupedObjects, startNavigate: props.startNavigate }));
    }
    const sortedWidgetsComponents = [];
    for (let i = 0, count = sortedWidgetShortnames.length; i < count; i++) {
        sortedWidgetsComponents.push(widgetsComponentByShortname[sortedWidgetShortnames[i]]);
    }
    return (react_1.default.createElement("section", { className: `survey-section survey-section-shortname-${props.shortname}` },
        react_1.default.createElement("div", { className: "survey-section__content" },
            ((_a = props === null || props === void 0 ? void 0 : props.sectionConfig) === null || _a === void 0 ? void 0 : _a.title) && (project_config_1.default === null || project_config_1.default === void 0 ? void 0 : project_config_1.default.hasSectionProgressBar) === true && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SectionProgressBar_1.default, { title: props.sectionConfig.title, interview: props.interview, sectionName: props.shortname, sections: props.surveyContext.sections }))),
            react_1.default.createElement("div", null, sortedWidgetsComponents))));
};
exports.Section = Section;
exports.default = (0, WithSurveyContextHoc_1.withSurveyContext)(exports.Section);
//# sourceMappingURL=Section.js.map